import React from 'react'
import Navbar from '../defaultComponents/Navbar'
import Footer from '../defaultComponents/Footer'

import styled from 'styled-components'

import { useNavigate } from 'react-router-dom'

import AddBoxIcon from '@mui/icons-material/AddBox';

const PageWrapper = styled.div`
  font-family: Inter;
`

const TitleBanner = styled.div`
  display: flex;
  justify-content: center;
`

const TitleBox = styled.div`
  font-size: 2rem;
  font-family: Montserrat;
  font-weight: bold;
  width: 90vw;
  padding-left: 2vw;
`

const JobsBanner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const JobBoxContainer = styled.div`
  min-height: 60vh;
  width: 90vw;
  gap: 1vw;
  padding: 2vw 2vw 2vw 2vw;

  display:grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  grid-gap:10px;

  grid-template-columns: repeat(3, minmax(100px, 1fr));
  grid-template-rows: repeat(3, minmax(100px, 1fr));
`

const JobBox = styled.div`
  display: flex;
  font-family: Inter;

  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding-top: 1vh;
  padding-bottom: 1vh;

  cursor: pointer;
  @media (min-width: 701px) {
    &:hover{
      border-color: black;
      
      background: black;
    }
  }

  padding: 10px 20px 10px 20px;
  

  background: #333333;
  border: 1px solid black;
  border-radius: 15px;
  color: white;

  text-align: center;
`

const JobTitle = styled.div`
  font-size: 2rem;
  font-family: Montserrat;
  font-weight: bold;
`

const AddShiftButton = styled.div`
  cursor: pointer;
`

export default function AllocationsPage() {

  const navigate = useNavigate();

  const [jobs, setJobs] = React.useState([])
  const getAllocationJobs = async () => {
    try {
      const res = await fetch("/api/allocations/jobs");

      const data = await res.json();

      // console.log(JSON.stringify(data));

      setJobs(data);
    } catch (error) {
      console.error("Error:", error)
    }
  }

  React.useEffect(() => {
    getAllocationJobs();
  }, [])

  return (
    <>
      <Navbar pageType="Dashboard" />
      <PageWrapper>
        <TitleBanner>
          <TitleBox>ALLOCATIONS</TitleBox>
          <AddShiftButton ><AddBoxIcon sx={{color:"#4ddc00", fontSize:"3rem"}}/></AddShiftButton>
        </TitleBanner>

        <JobsBanner>
          <JobBoxContainer>

            {jobs.map((job, idx) => (
              <JobBox key={job.job_id} onClick={() => navigate(`Job/${job.job_id}`)}>
                <JobTitle>{job.job_name}</JobTitle>
              </JobBox>
            ))}
          </JobBoxContainer>
        </JobsBanner>
        <Footer />
      </PageWrapper>
    </>
  )
}
